import $ from 'jquery';

export default function veryLazyLoadingOfMegaMenuPanelImages() {
    const $panelImages = $('.primary-nav-panel-content-image img');
    $panelImages.each(function() {
        const
            $image = $(this),
            $dropdown = $image.closest('.dropdown');
        $dropdown.one('show.bs.dropdown', () => {
            const
                dataSrc = $image.attr('data-src'),
                dataSrcSet = $image.attr('data-srcset');
            if (dataSrc) {
                $image.attr('src', dataSrc).removeAttr('data-src');
            }
            if (dataSrcSet) {
                $image.attr('srcset', dataSrcSet).removeAttr('data-srcset');
            }
        });
    });
}
